/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBanners200ResponseBannersInner
 */
export interface GetBanners200ResponseBannersInner {
    /**
     * バナーID
     * @type {number}
     * @memberof GetBanners200ResponseBannersInner
     */
    bannerId: number;
    /**
     * 表示場所
     * @type {number}
     * @memberof GetBanners200ResponseBannersInner
     */
    displayLocation: number;
    /**
     * 画像URL
     * @type {string}
     * @memberof GetBanners200ResponseBannersInner
     */
    image: string;
    /**
     * タイトル
     * @type {string}
     * @memberof GetBanners200ResponseBannersInner
     */
    title: string;
    /**
     * 説明文
     * @type {string}
     * @memberof GetBanners200ResponseBannersInner
     */
    description: string;
    /**
     * CTA
     * @type {string}
     * @memberof GetBanners200ResponseBannersInner
     */
    cta: string;
    /**
     * 表示間隔
     * @type {number}
     * @memberof GetBanners200ResponseBannersInner
     */
    displayInterval: number;
    /**
     * URL (サイト内リンクは/から記載)
     * @type {string}
     * @memberof GetBanners200ResponseBannersInner
     */
    url: string;
}

/**
 * Check if a given object implements the GetBanners200ResponseBannersInner interface.
 */
export function instanceOfGetBanners200ResponseBannersInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bannerId" in value;
    isInstance = isInstance && "displayLocation" in value;
    isInstance = isInstance && "image" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "cta" in value;
    isInstance = isInstance && "displayInterval" in value;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function GetBanners200ResponseBannersInnerFromJSON(json: any): GetBanners200ResponseBannersInner {
    return GetBanners200ResponseBannersInnerFromJSONTyped(json, false);
}

export function GetBanners200ResponseBannersInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBanners200ResponseBannersInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bannerId': json['banner_id'],
        'displayLocation': json['display_location'],
        'image': json['image'],
        'title': json['title'],
        'description': json['description'],
        'cta': json['cta'],
        'displayInterval': json['display_interval'],
        'url': json['url'],
    };
}

export function GetBanners200ResponseBannersInnerToJSON(value?: GetBanners200ResponseBannersInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'banner_id': value.bannerId,
        'display_location': value.displayLocation,
        'image': value.image,
        'title': value.title,
        'description': value.description,
        'cta': value.cta,
        'display_interval': value.displayInterval,
        'url': value.url,
    };
}

